export default __webpack_public_path__ + "static/media/wallet.125e05f9.mp4";